require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-to-mars-and-beyond-student-project-gives-glimpse-of-rover-life-on-the-red-planet.json") })
        }
      }, "path---blog-to-mars-and-beyond-student-project-gives-glimpse-of-rover-life-on-the-red-planet");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-to-mars-and-beyond-student-project-gives-glimpse-of-rover-life-on-the-red-planet!./.cache/json/blog-to-mars-and-beyond-student-project-gives-glimpse-of-rover-life-on-the-red-planet.json
// module id = 1134
// module chunks = 231608221292675